import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './index.css';
import { UnsupportedHost } from './components/shared/UnsupportedHost';
import { PORTAL_BRAND } from './config/branding';
import { ThemeProvider } from './providers/ThemeProvider';
import { capturePurchaseLink } from './services/checkoutService';
import { applyBrandToDocument } from '../../../packages/ui/src/branding/host-brand';

capturePurchaseLink();

applyBrandToDocument(document, PORTAL_BRAND, 'portal');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        {PORTAL_BRAND.id === 'neutral' ? <UnsupportedHost /> : <App />}
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
